var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUlettiLogoText(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 151.874,
    height: 49.724,
    viewBox: "0 0 151.874 49.724",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_667",
    "data-name": "Rectangle 667",
    width: 49.724,
    height: 49.724,
    fill: "#0c31ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3900",
    "data-name": "Group 3900",
    transform: "translate(-648.85 -34.126)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3906",
    "data-name": "Group 3906"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3718",
    "data-name": "Group 3718",
    transform: "translate(405.833 -606.309)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11739",
    "data-name": "Path 11739",
    d: "M306.783,653.919h4.95v16.169a6.007,6.007,0,0,0,.715,3.062,4.478,4.478,0,0,0,1.98,1.834,6.673,6.673,0,0,0,2.915.6,7.011,7.011,0,0,0,2.989-.6,4.438,4.438,0,0,0,2.017-1.834,6,6,0,0,0,.715-3.062V653.919h4.95v15.95a10.063,10.063,0,0,1-.9,4.4,9.1,9.1,0,0,1-2.4,3.117,10.038,10.038,0,0,1-3.41,1.852,13.266,13.266,0,0,1-4.033.6,12.207,12.207,0,0,1-5.151-1.1,9.077,9.077,0,0,1-3.868-3.318,9.859,9.859,0,0,1-1.467-5.554Z",
    transform: "translate(0 -0.217)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11740",
    "data-name": "Path 11740",
    d: "M340.312,652.969h4.693v26.4h-4.693Z",
    transform: "translate(-7.643)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11741",
    "data-name": "Path 11741",
    d: "M360.321,681.931a9.566,9.566,0,0,1-4.877-1.209,8.373,8.373,0,0,1-3.245-3.374,10.427,10.427,0,0,1-1.155-4.986A9.69,9.69,0,0,1,352.2,667.6a8.669,8.669,0,0,1,3.172-3.3,8.8,8.8,0,0,1,4.62-1.21,9.451,9.451,0,0,1,4.657,1.118,7.839,7.839,0,0,1,3.135,3.172,10.112,10.112,0,0,1,1.155,4.766,8.278,8.278,0,0,1-.055.9q-.054.494-.165,1.045H356.1a4.12,4.12,0,0,0,2.255,3.282,4.49,4.49,0,0,0,2.071.459,5.224,5.224,0,0,0,2.4-.55,3.383,3.383,0,0,0,1.558-1.5l4.18,1.21a8.2,8.2,0,0,1-3.281,3.649A9.51,9.51,0,0,1,360.321,681.931Zm3.483-11.256a4,4,0,0,0-.586-1.851,3.64,3.64,0,0,0-1.339-1.284,3.83,3.83,0,0,0-1.888-.458,3.742,3.742,0,0,0-1.723.494,4.318,4.318,0,0,0-1.375,1.248,4.384,4.384,0,0,0-.751,1.851Z",
    transform: "translate(-10.089 -2.306)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11742",
    "data-name": "Path 11742",
    d: "M379.209,661.9v-5.133h4.8V661.9h4.034v4.144h-4.034v7.443a2.792,2.792,0,0,0,.587,2.035,2.247,2.247,0,0,0,1.54.6,10.441,10.441,0,0,0,1.943-.11v4.034a11.583,11.583,0,0,1-3.337.238,6.442,6.442,0,0,1-2.841-.862,5.174,5.174,0,0,1-1.962-2.181,8.323,8.323,0,0,1-.733-3.758v-7.443h-2.566V661.9Z",
    transform: "translate(-15.924 -0.866)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11743",
    "data-name": "Path 11743",
    d: "M396.638,661.9v-5.133h4.8V661.9h4.033v4.144h-4.033v7.443a2.791,2.791,0,0,0,.587,2.035,2.246,2.246,0,0,0,1.54.6,10.441,10.441,0,0,0,1.943-.11v4.034a11.583,11.583,0,0,1-3.337.238,6.445,6.445,0,0,1-2.842-.862,5.177,5.177,0,0,1-1.961-2.181,8.323,8.323,0,0,1-.733-3.758v-7.443h-2.567V661.9Z",
    transform: "translate(-19.896 -0.866)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11744",
    "data-name": "Path 11744",
    d: "M416.169,658.689a2.925,2.925,0,0,1-2.164-.844,2.855,2.855,0,0,1,0-4.051,2.964,2.964,0,0,1,2.164-.825,2.933,2.933,0,0,1,2.108.825,2.811,2.811,0,0,1,0,4.051A2.9,2.9,0,0,1,416.169,658.689Zm-2.383,2.346h4.73v18.333h-4.73Z",
    transform: "translate(-24.248)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3737",
    "data-name": "Group 3737",
    transform: "translate(648.85 34.126)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3596",
    "data-name": "Group 3596",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11695",
    "data-name": "Path 11695",
    d: "M24.793,0A24.792,24.792,0,1,0,49.585,24.792,24.793,24.793,0,0,0,24.793,0m8.069,35.123H16.724a2.43,2.43,0,0,1-2.393-2.854l2.8-15.8a2.43,2.43,0,0,1,2.393-2.006H30.557a2.43,2.43,0,0,1,2.4,2.079l2.3,15.8a2.43,2.43,0,0,1-2.4,2.781",
    transform: "translate(0 0.139)",
    fill: "#0c31ff"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUlettiLogoText);
export default __webpack_public_path__ + "static/media/uletti-logo-text.1b6b4b2097051f0c2dbb6b47c0cdbbdb.svg";
export { ForwardRef as ReactComponent };